<template>
   <div>
     <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <div class="modt-box">归属地管理</div>
      <el-col :span="4" class="btn"> 
        <el-button type="primary" @click="addRole">新增</el-button> 
        </el-col>

        <el-table size="small" :data="listData" highlight-current-row   border element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column sortable   align="center" prop="name" label="角色名称" width="100">
      </el-table-column>


        <el-table-column sortable  align="center" prop="create_time" label="创建时间" width="150">
      </el-table-column>
        <el-table-column sortable  align="center" prop="update_time" label="更新时间" width="150">
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editModule(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteBelong(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      
      <el-col :span="18">
        <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
        width="30%"
       @click="dialogClose">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="归属地" prop="name">
            <el-input size="small" v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  v-show="addshow" @click="saveModule('form')">保存</el-button>  
          </el-form-item>
        </el-form>
         </el-dialog>
      </el-col>
     

    </el-row>
    </div>   


</template>

<script>

import { saveBelong,ListBelong,editBelong ,deleteBelong} from '@/api/userFun'
export default {
 
    data(){
        return{
            active_value:1,
            inactive_value:0,
         
            addshow:true,
           
            dialogVisible:false,
            showdelete:false,
            checkedId:'',
            form: {
             name:'',
     
             },
             listData:[],
             
              // rules表单验证
            rules: {
                name: [
                { required: true, message: '请输入名称', trigger: 'blur' }
                ],
            },
        }
    },
    created(){
       
       this.getdata();
    },
   methods: {
    dialogClose(){
      this.dialogVisible=true;
     //this.form="";
    },
    addRole(){
      this.dialogVisible=true;
    },

   handleCheckedCitiesChange(value) {

        console.log(value);
        let checkedCount = value.length;
       // this.checkAll = checkedCount === this.cities.length;
       // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
    getdata(){
        ListBelong().then(res=>{
            this.$nextTick(()=>{
              this.listData=res.data;
            });
                
        })
    },
    // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.addshow=false;
        this.checkedId=data.value;
        //this.$refs.tree.setCheckedNodes([])
        menuById(this.checkedId).then(res=>{
            this.form=res.data;
        });
        this.showdelete = true

      } else {
        this. clearForm('form');
        console.log(this.form);
        this.addshow=true;
        this.showdelete = false
      }
    },

     clearForm(form){
      //  this.$refs[form].resetFields();
        this.form.name="";
       // this.form.rules="";
        this.dialogVisible=false;
        if(this.form.hasOwnProperty('id')){
            delete this.form.id;
        }

     },  
    
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          saveBelong(this.form)
            .then(res => {
            // this.dialogClose();
              this.dialogVisible=false;
             // this.form="";
              this.getdata();
              this.clearForm('form');
             // console.log(this.form);
            //   this.getmenu()
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteBelong(index,row) {
      let deleteId={
        id:row['id'],
        };
      deleteBelong(deleteId)
        .then(res => {
          this.getdata()
         this. clearForm('form');
          this.$message.error('删除成功！')
        })
    },

     // 编辑菜单
    editModule(index,row) {
      let editId={
        id:row['id'],
        };
      editBelong(editId)
        .then(res => {
          this.$nextTick(()=>{
            this.form=res.data
          });
          
          this.dialogVisible=true;
          //this. clearForm('form');
         // this.$message.error('菜单管理列表删除成功！')
        })
    },


     statusStyle(status){
      if(status==1){
        return 'success';
      }else if(status==0){
          return 'info';
      }else{
        return 'danger';
      }
      
    },
    StateToStr(status){
      if(status==1){
        return '生效';
      }else if(status==0){
        return '无效';
      }
      else{
        return '未知状态';
      }
    }, 
  
   },

}
</script>
<style>
.btn{
  margin-bottom: 1.58rem;
}
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/belong.vue